export enum TopChartType {
    issuers = "issuers",
    arrangers = "arrangers",
    trustees = "trustees",
}
